<template>
  <v-card>
    <v-card-text class="text-center">
      <p>Please wait while you're redirected back to Nexus Connect.</p>
      <p>Redirecting you in {{ seconds }}...</p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CompletedOrder",

  data() {
    return {
      seconds: 5,
    };
  },

  mounted() {
    setInterval(() => {
      if (this.seconds > 0) {
        this.seconds -= 1;
      } else {
        window.close();
      }
    }, 1_000);
  },
};
</script>
